import { Button } from "@mui/material";
import React, { useState } from "react";
import config from "../config";
import { Login as LoginIcon } from "@mui/icons-material";
import ConfirmNavigationModal from "./ConfirmNavigationModal";

export const LoginWithDiscordBtn = ({ isSmallScreen = false }) => {

  const DISCORD_CLIENT_ID = config.REACT_APP_DISCORD_CLIENT_ID
  const REDIRECT_URI = config.REACT_APP_DISCORD_REDIRECT_URI

    const [modalOpen, setModalOpen] = useState(false)
    const [pendingNavigation, setPendingNavigation] = useState({
      url: "",
      name: "",
      isLogin: false,
    })
    
    const confirmNavigation = () => {
      if (pendingNavigation.isLogin) {
        // For login, navigate in the same window
        window.location.href = pendingNavigation.url
      } else {
        // For regular external links, open in a new tab
        window.open(pendingNavigation.url, "_blank", "noopener,noreferrer")
      }
      setModalOpen(false)
    }

    const handleLogin = () => {
        setPendingNavigation({
          url: `https://discord.com/api/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=identify%20guilds`,
          name: "Discord Login",
          isLogin: true,
        })
        setModalOpen(true)
      }

    return (
        <>
        
        <Button
        variant="contained"
        size="small"
        onClick={handleLogin}
        startIcon={!isSmallScreen && <LoginIcon />}
        sx={{
        background: "linear-gradient(45deg, #00e5ff 30%, #2979ff 90%)",
        boxShadow: "0 0 10px rgba(0, 229, 255, 0.5)",
        minWidth: isSmallScreen ? 0 : "auto",
        p: isSmallScreen ? 1 : "auto",
        "&:hover": {
            boxShadow: "0 0 15px rgba(0, 229, 255, 0.8)",
        },
        }}
        >
            {isSmallScreen ? <LoginIcon fontSize="small" /> : "Login with Discord"}
        </Button>
              <ConfirmNavigationModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmNavigation}
                destination={pendingNavigation.url}
                destinationName={pendingNavigation.name}
                isLogin={pendingNavigation.isLogin}
              />
        </>
    );
}



